import {
  clerkClientConfig,
  clerkPublishableKeyConfigErrorMessage,
} from "../domain/config";

/**
 * Clerk is enabled only when a usable publishable key is present. The hosted
 * mock site has had keys pasted as `NAME=pk_...`; normalize that shape so a
 * malformed local value does not blank-screen the app.
 *
 * A live Clerk key is domain-bound, so local development with the production
 * key falls back to the no-auth demo path instead of rendering a blank app.
 */
const hostname = typeof window === "undefined" ? null : window.location.hostname;
const clerkConfig = clerkClientConfig({
  rawPublishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
  hostname,
});
if (clerkConfig.error !== null) console.warn(clerkPublishableKeyConfigErrorMessage(clerkConfig.error));

export const clerkPublishableKey = clerkConfig.publishableKey;
export const isClerkEnabled = clerkConfig.enabled;
